import { createSelector } from 'redux-orm';
import { orm } from 'model';
import { BP_MISSED_PAYMENT } from 'consts';

export const selector = createSelector(orm.ActionInsight);

export const selectorMissedPayments = createSelector(
  orm,
  (state, { fspId, payerId }) => ({ fspId, payerId }),
  ({ ActionInsight }, { fspId, payerId }) =>
    ActionInsight.filter(
      ({ eventName, fspId: aiFspId, payerId: aiPayerId }) =>
        eventName === BP_MISSED_PAYMENT &&
        aiFspId === fspId &&
        aiPayerId === payerId
    ).toRefArray()
);
